export default {
    tripletEarlyPregnancy: 'Triplet Early Pregnancy',
    indication: "indication",
    medicalAbbreviationTest: "medicalAbbreviationTest",
    medicalAbbreviationTestDate: "medicalAbbreviationTestDate",
    examinationMethod: "examinationMethod",
    examinationView: "examinationView",
    gestationalMedicalAbbreviationTest: "gestationalMedicalAbbreviationTest",
    gestationalMedicalAbbreviationTestWeek: "gestationalMedicalAbbreviationTestWeek",
    gestationalMedicalAbbreviationTestDay: "gestationalMedicalAbbreviationTestDay",

    aYolkSacType: "aYolkSacType",
    aEmbryoSonographicType: "aEmbryoSonographicType",
    aCRL: "aCRL",
    aCRLEquatWeek: "aCRLEquatWeek",
    aCRLEquatDay: "aCRLEquatDay",
    aCardiacActivity: "aCardiacActivity",

    bYolkSacType: "bYolkSacType",
    bEmbryoSonographicType: "bEmbryoSonographicType",
    bCRL: "bCRL",
    bCRLEquatWeek: "bCRLEquatWeek",
    bCRLEquatDay: "bCRLEquatDay",
    bCardiacActivity: "bCardiacActivity",

    cYolkSacType: "cYolkSacType",
    cEmbryoSonographicType: "cEmbryoSonographicType",
    cCRL: "cCRL",
    cCRLEquatWeek: "cCRLEquatWeek",
    cCRLEquatDay: "cCRLEquatDay",
    cCardiacActivity: "cCardiacActivity",

    uterusPosition: "uterusPosition",
    bothOvariesType: "bothOvariesType",
    pouchDouglasType: "pouchDouglasType",
    freeFluidType: "freeFluidType",
    impressionLocation: "impressionLocation",
    planAndFollowUpType: "planAndFollowUpType",
    finalDescription: "finalDescription",
}